import { render, staticRenderFns } from "./commissionDetails.vue?vue&type=template&id=da84e7e6&scoped=true"
import script from "./commissionDetails.vue?vue&type=script&lang=js"
export * from "./commissionDetails.vue?vue&type=script&lang=js"
import style0 from "./commissionDetails.vue?vue&type=style&index=0&id=da84e7e6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da84e7e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da84e7e6')) {
      api.createRecord('da84e7e6', component.options)
    } else {
      api.reload('da84e7e6', component.options)
    }
    module.hot.accept("./commissionDetails.vue?vue&type=template&id=da84e7e6&scoped=true", function () {
      api.rerender('da84e7e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/commissionDetails.vue"
export default component.exports